import { formatCurrency, formatEthSpot } from '@/lib/format'

interface FundingProgressProps {
  raised: number
  goal: number
  accent: 'lime' | 'orange'
  showLabels?: boolean
  unit?: 'usd' | 'eth'
}

function FundingProgress({ raised, goal, accent, showLabels = true, unit = 'usd' }: FundingProgressProps) {
  const pct = goal > 0 ? Math.min(100, (raised / goal) * 100) : 0
  const barColor = accent === 'lime' ? 'bg-lime-400' : 'bg-orange-400'
  const glow = accent === 'lime' ? 'shadow-[0_0_12px_rgba(163,230,53,0.45)]' : 'shadow-[0_0_12px_rgba(251,146,60,0.4)]'
  const formatValue = unit === 'eth' ? formatEthSpot : formatCurrency

  return (
    <div>
      {showLabels
        ? (
            <div className="mb-1.5 flex items-baseline justify-between text-xs">
              <span className="font-medium text-white">{formatValue(raised)}</span>
              <span className="text-zinc-500">
                raised of
                {' '}
                {formatValue(goal)}
              </span>
            </div>
          )
        : null}
      <div
        className="h-1.5 w-full overflow-hidden rounded-full bg-white/10"
        role="progressbar"
        aria-valuenow={Math.round(pct)}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Funding progress"
      >
        <div
          className={`h-full rounded-full ${barColor} ${glow} transition-all`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {showLabels
        ? (
            <div className="mt-1 text-right text-[11px] text-zinc-500">
              {pct.toFixed(0)}
              % funded
            </div>
          )
        : null}
    </div>
  )
}

export default FundingProgress
